import {
  Activity,
  BarChart3,
  Briefcase,
  Building,
  Building2,
  Cloud,
  Compass,
  Cpu,
  Database,
  Factory,
  GraduationCap,
  Handshake,
  HeartPulse,
  Landmark,
  Layers,
  Lightbulb,
  LineChart,
  Mail,
  Search,
  SendHorizontal,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  Target,
  TrendingUp,
  UserCheck,
  Users,
  Zap,
} from "lucide-react";

/**
 * Data files reference icons by string key so they stay plain, API-ready
 * data (no JSX/components inside Data/*.js). Sections resolve the key here.
 */
export const ICONS = {
  activity: Activity,
  barChart3: BarChart3,
  briefcase: Briefcase,
  building: Building,
  building2: Building2,
  cloud: Cloud,
  compass: Compass,
  cpu: Cpu,
  database: Database,
  factory: Factory,
  graduationCap: GraduationCap,
  handshake: Handshake,
  heartPulse: HeartPulse,
  landmark: Landmark,
  layers: Layers,
  lightbulb: Lightbulb,
  lineChart: LineChart,
  mail: Mail,
  search: Search,
  sendHorizontal: SendHorizontal,
  shieldCheck: ShieldCheck,
  shoppingCart: ShoppingCart,
  sparkles: Sparkles,
  target: Target,
  trendingUp: TrendingUp,
  userCheck: UserCheck,
  users: Users,
  zap: Zap,
};

export const getIcon = (key, size = 24) => {
  const IconComponent = ICONS[key] || Sparkles;
  return <IconComponent size={size} />;
};
